import { render, staticRenderFns } from "./RoleStaff.vue?vue&type=template&id=7fa1621e&scoped=true"
import script from "./RoleStaff.vue?vue&type=script&lang=js"
export * from "./RoleStaff.vue?vue&type=script&lang=js"
import style0 from "./RoleStaff.vue?vue&type=style&index=0&id=7fa1621e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa1621e",
  null
  
)

export default component.exports